/* istanbul ignore file */

import { addressEdit } from 'utils/FlowProvider/redirects'
import { mapRequirementToRoute } from '../../requirementsMapping'
import { FlowEntry, FlowRoute } from '../../types'

export const earlyOnboarding: FlowEntry[] = [
  {
    page: FlowRoute.Welcome,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
    isFirstPage: true,
  },
  {
    page: FlowRoute.DateOfBirth,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.ContactInfo,
    actions: [
      { name: 'continue', goTo: mapRequirementToRoute },
      {
        name: 'choose',
        goTo: () => FlowRoute.AddressSuggestion,
      },
      {
        name: 'more_info',
        goTo: () => FlowRoute.AddressInvalid,
      },
    ],
  },
  {
    page: FlowRoute.SSN,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.InvestorQuestions,
    actions: [{ name: 'continue', goTo: mapRequirementToRoute }],
  },
  {
    page: FlowRoute.AddressInvalid,
    actions: [
      {
        name: 'continue',
        goTo: addressEdit,
      },
    ],
  },
  {
    page: FlowRoute.AddressSuggestion,
    actions: [
      {
        name: 'continue',
        goTo: mapRequirementToRoute,
      },
      {
        name: 'update',
        goTo: addressEdit,
      },
    ],
  },
]
